import React, { useEffect } from "react";
import { Row, Tabs, Tab, Badge } from "react-bootstrap";
import WhatsappMessageEdit from "../../pages/Campaigns/_WhatsappMessageEdit";

import PropTypes from "prop-types";
const WhatsappMessageControl = ({
  values,
  setValues,
  onChange,
  fieldsInfo,
}) => {
  const onChangeWhatsappMessage = (message) => {
    setValues({ ...values, whmessage: message });
  };

  const onChangeWhatsappTemplate = (message) => {
    setValues({ ...values, selectedTemplate: message });
  };

  const cleanWhatsappParameters = () => {
    setValues({ ...values, whparameters: "" });
  };

  useEffect(() => {
    let messageWithTemplate = values.whmessage;

    try {
      const matches = messageWithTemplate.match(/{{\d+}}/g);

      matches &&
        matches.forEach((match) => {
          var paramArray = values.whparameters.split(",");
          let field = paramArray[match.replace("{{", "").replace("}}", "") - 1];

          var currentK = fieldsInfo.filter(
            (item) => item.vc_keycolumn == field.replace(/\s+/g, "")
          );

          messageWithTemplate = messageWithTemplate.replace(
            match,
            currentK[0].vc_value
          );
        });
    } catch (error) {
      console.log(error);
    }

    setValues({
      ...values,
      ["whtemplate"]: messageWithTemplate
        .replaceAll("{", "")
        .replaceAll("}", ""),
    });
  }, [values.whmessage]);
  return (
    <>
      <Row>
        <WhatsappMessageEdit
          onChangeWhatsappMessage={onChangeWhatsappMessage}
          defaultValue={values.whmessage}
          name="whmessage"
          cleanWhatsappParameters={cleanWhatsappParameters}
          valueParameters={values.whparameters}
          changeHandler={onChange}
          onChangeWhatsappTemplate={onChangeWhatsappTemplate}
        ></WhatsappMessageEdit>
      </Row>
      <Row>
        {values.whtemplate && (
          <>
            <h5 className="PrevTitleModal">Previsualización:</h5>
            <div className="contenedo_msj">
              <div className="mensaje-izq">
                <div className="cuerpo_msj">
                  {
                    <div
                      className="msj-texto"
                      dangerouslySetInnerHTML={{
                        __html: values.whtemplate,
                      }}
                    ></div>
                  }
                </div>
              </div>
            </div>
            <hr />
          </>
        )}
      </Row>
      <Row>
        <Tabs
          // activeKey={isWhatsApp ? "AddFields" : "ShortLinks"}
          activeKey={"AddFields"}
          id="fill-tab-example"
          className="tabsBottom"
          fill
        >
          <Tab eventKey="AddFields" title="Template">
            <div className="ShortLink" style={{ paddingTop: "10px" }}>
              <h5>
                Al darle click se agregará el campo relacionado con el alias que
                aparece a continuación:
              </h5>
              <div className="AllLinks">
                <>
                  {fieldsInfo &&
                    fieldsInfo.map((field) => {
                      return (
                        <>
                          <Badge
                            onClick={() => {
                              //   setMessageText(field.vc_keycolumn);
                              setValues({
                                ...values,
                                whmessage:
                                  values.whmessage +
                                  " {" +
                                  field.vc_keycolumn +
                                  "} ",
                                whparameters:
                                  (values.whparameters
                                    ? values.whparameters + " ,"
                                    : "") +
                                  field.vc_keycolumn +
                                  " ",
                              });
                            }}
                            bg="primary"
                          >
                            {field.vc_keycolumn}
                          </Badge>
                        </>
                      );
                    })}
                </>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Row>
    </>
  );
};
WhatsappMessageControl.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldsInfo: PropTypes.array.isRequired,
  clickLink: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
};

export default WhatsappMessageControl;
